import React from "react";
import { ThemeProvider, CSSReset } from "@chakra-ui/core";
import customTheme from "./theme/theme";
import Routes from "./routes";
import { AuthProvider } from "./hooks/useAuth";
import { UserPreferencesProvider } from "./hooks/useUserPreferences";

function App() {
  return (
    <AuthProvider>
      <UserPreferencesProvider>
        <ThemeProvider theme={customTheme}>
          <CSSReset />
          <Routes />
        </ThemeProvider>
      </UserPreferencesProvider>
    </AuthProvider>
  );
}

export default App;
